export const cleanJoin = (...classes) =>
  classes
    ? classes
        .filter(Boolean)
        .map((_) => _.trim())
        .filter((_) => _.length > 0)
        .join(" ")
    : "";

export const cutShort = (str, toLength = 0, append = "") => {
  if (str.length > toLength) {
    if (toLength === 0) {
      return str;
    } else {
      return str.substring(0, Math.abs(toLength) - append.length) + append;
    }
  }
  return str;
};
